<template>
  <div
    class="mr-4 relative w-20 h-10 bg-gray-300 rounded-full cursor-pointer transition-colors duration-300"
    @click="toggleLang"
    :class="{ 'bg-gray-300 ': isEnglish }"
  >
    <!-- sliding circle -->
    <div
      class="absolute top-1 left-1 w-8 h-8 bg-primary-600 rounded-full shadow-md transform transition-transform duration-300"
      :class="isEnglish ? 'translate-x-10' : 'translate-x-0'"
    ></div>

    <!-- language labels -->
    <div class="absolute inset-0 flex items-center justify-between px-3 text-sm font-bold text-white">
      <span :class="{ 'text-gray-600': isEnglish }">ID</span>
      <span :class="{ 'text-gray-600': !isEnglish }">EN</span>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    isEnglish() {
      return this.$i18n.locale === 'en';
    },
  },
  methods: {
    toggleLang() {
      const newLang = this.isEnglish ? 'id' : 'en';
      this.$i18n.locale = newLang;
      localStorage.setItem('lang', newLang);
    },
  },
};
</script>

